import { TFunction } from 'react-i18next';
import { ItemGroup, MarkupItem } from "features/projects/projectsTypes";

// Legacy cost items for backward compatibility
const INITIAL_COST_ITEMS = [
  {
    name: 'Material Costs',
    amount: 0,
    category: 'material',
    description: '',
  },
  {
    name: 'Office Overhead',
    amount: 0,
    category: 'overhead',
    description: '',
  },
  {
    name: 'Company Profit',
    amount: 0,
    category: 'profit',
    description: '',
  },
  {
    name: 'Permit Costs',
    amount: 0,
    category: 'permit',
    description: '',
  },
  {
    name: 'Draftsman Pay',
    amount: 0,
    category: 'labor',
    description: '',
  },
  {
    name: 'Installer Pay',
    amount: 0,
    category: 'labor',
    description: '',
  },
  {
    name: 'Sales Commission',
    amount: 0,
    category: 'labor',
    description: '',
  },
  {
    name: 'Sales Manager Pay',
    amount: 0,
    category: 'labor',
    description: '',
  },
  {
    name: 'Project Manager Pay',
    amount: 0,
    category: 'labor',
    description: '',
  }
];

// New budget structure defaults
const INITIAL_ITEM_GROUPS: ItemGroup[] = [
  {
    groupLabel: 'Materials',
    isCollapsed: false,
    jobItems: []
  }
];

const DEFAULT_MARKUP_ITEMS: MarkupItem[] = [
  {
    itemName: 'Sales',
    markupPercentage: 10.0,
    calculatedAmount: 0
  },
  {
    itemName: "Pombo's",
    markupPercentage: 10.0,
    calculatedAmount: 0
  },
  {
    itemName: 'Project Manager',
    markupPercentage: 3.0,
    calculatedAmount: 0
  },
  {
    itemName: 'Overhead',
    markupPercentage: 3.0,
    calculatedAmount: 0
  },
  {
    itemName: 'Drafting',
    markupPercentage: 2.5,
    calculatedAmount: 0
  }
];

const QUANTITY_UNITS = [
  'LF', // Linear Feet
  'SqFt', // Square Feet
  'EA', // Each
  'CY', // Cubic Yards
  'LB', // Pounds
  'HR', // Hours
  'SY', // Square Yards
  'FT', // Feet
  'IN', // Inches
  'LOT' // Lot
];

const AVAILABLE_ROLES = [
  { value: 'ADMIN', label: 'Administrator' },
  { value: 'DRAFTSMAN', label: 'Draftsman' },
  { value: 'OFFICE', label: 'Office Staff' },
  { value: 'PROJECT_MANAGER', label: 'Project Manager' },
  { value: 'SALES', label: 'Sales' },
  { value: 'TECHNICIAN', label: 'Technician' },
  { value: 'INSTALLER', label: 'Installer' }
];

export const getProjectStatusList = (t: TFunction) => [
  { label: t('CREATE_PROJECT_STATUS_PENDING', { ns: 'projects' }), value: 'pending' },
  { label: t('CREATE_PROJECT_STATUS_SOLD', { ns: 'projects' }), value: 'sold' },
  { label: t('CREATE_PROJECT_STATUS_PRE_CONSTRUCTION', { ns: 'projects' }), value: 'pre-construction' },
  { label: t('CREATE_PROJECT_STATUS_PERMITTING', { ns: 'projects' }), value: 'permitting' },
  { label: t('CREATE_PROJECT_STATUS_CONSTRUCTION', { ns: 'projects' }), value: 'construction' },
  { label: t('CREATE_PROJECT_STATUS_DONE', { ns: 'projects' }), value: 'done' }
];

export {
  INITIAL_COST_ITEMS,
  INITIAL_ITEM_GROUPS,
  DEFAULT_MARKUP_ITEMS,
  QUANTITY_UNITS,
  AVAILABLE_ROLES,
};
